// runs in browser only
import Vue from 'vue'
import { createApp } from '../main'
import { getAsyncData } from './util'

const fetch = () => import(/* webpackChunkName: "index-id-fetch" */ '@/views/Index/fetch.js')

Vue.devtools = process.env.NODE_ENV

const ClientRender = async () => {
  const reactiveFetchData = {
    value: window.__INITIAL_DATA__ ?? {}
  }

  const { router, store, app } = createApp({reactiveFetchData})

  if (window.__INITIAL_STATE__) {
    store.replaceState(window.__INITIAL_STATE__)
  }

  router.onReady(async () => {
    const fetchData = await getAsyncData({fetch, store})
    reactiveFetchData.value = fetchData
    app.$mount('#app', true)
  })
}

ClientRender()